import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getContraVoucherNumber(cookies, plantId, contraDate) {
    const url = `${apiBaseUrl}/contra_vouchers/contra_voucher_number/?plant_id=${plantId}&contra_date=${contraDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getContraVouchers(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/contra_vouchers/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getContraVoucherDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/contra_vouchers/${id}/`).then((r) => r.data);
}

export function createContraVoucher(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/contra_vouchers/`, payload).then((r) => r.data);
}

export function cancelContraVoucher(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/contra_vouchers/${id}/`, {}).then((r) => r.data);
}

export function deleteContraVoucher(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/contra_vouchers/${id}/`).then((r) => r.data);
}
